import React from 'react';
import { useLabels, usePrefs } from 'wsm-common-data';

const BackToTop = () => {
	const labels = useLabels();
	const { hideBackToTopButton } = usePrefs();
	if (hideBackToTopButton === 'true') return <></>;
	return (
		<div className="back-to-top">
			<a className="align-center" href="#top">
				<i className="ddc-icon ddc-icon-arrow3-up icon-size-5" />
				<p className="text-center text-bold mb-0">
					{labels.get('BACK_TO_TOP_TEXT')}
				</p>
			</a>
		</div>
	);
};

export default BackToTop;
